import { render, staticRenderFns } from "./blogfeed.vue?vue&type=template&id=7a36876b&scoped=true&"
import script from "./blogfeed.vue?vue&type=script&lang=js&"
export * from "./blogfeed.vue?vue&type=script&lang=js&"
import style0 from "./blogfeed.vue?vue&type=style&index=0&id=7a36876b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a36876b",
  null
  
)

export default component.exports